import { render, staticRenderFns } from "./account.vue?vue&type=template&id=a6a12f82&scoped=true"
import script from "./account.vue?vue&type=script&lang=js"
export * from "./account.vue?vue&type=script&lang=js"
import style0 from "./account.vue?vue&type=style&index=0&id=a6a12f82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a12f82",
  null
  
)

export default component.exports